/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/dome_ideo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-23-7.586h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zM13.454 24H9.637v-.636h3.817V24zm0-1.273h-3.182v-.636h3.182v.636zm0-1.272h-2.545v-.637h2.545v.637zM16 16.364a1.272 1.272 0 110-2.544 1.272 1.272 0 010 2.544zm0-3.819a2.547 2.547 0 00-2.546 2.545v5.092h-2.545V15.09a5.09 5.09 0 1110.182.001v5.091h-2.545v-5.091A2.547 2.547 0 0016 12.545zm5.729 9.546v.636h-3.183v-.636h3.183zm-3.183-.636v-.637h2.545v.637h-2.545zm0 2.545v-.636h3.817V24h-3.817zm8.704 3.25h-7.086l7.086-7.086v7.086zm0-15.414L20.164 4.75h7.086v7.086z"/>'
  }
})
